// client/src/app/api/apiSlice.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setCredentials, logOut } from '../../features/auth/authSlice'

const apiBaseUrl =
    process.env.REACT_APP_API_BASE_URL ||
    (process.env.NODE_ENV === "development"
        ? "http://localhost:3500"
        : "");


const baseQuery = fetchBaseQuery({
    baseUrl: apiBaseUrl, //   '' http://localhost:3500
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
        const token = getState().auth.token
        if (token) {
            headers.set("authorization", `Bearer ${token}`)
        }
        return headers
    }
})

const baseQueryWithReauth =
  async (
    args,
    api,
    extraOptions
  ) => {
    let result =
      await baseQuery(
        args,
        api,
        extraOptions
      );

    const status =
      result?.error?.status;

    if (
      status === 401 ||
      status === 403
    ) {
      console.log(
        'access token rejected; attempting refresh'
      );

      const refreshResult =
        await baseQuery(
          '/auth/refresh',
          api,
          extraOptions
        );

      if (
        refreshResult?.data?.accessToken
      ) {
        api.dispatch(
          setCredentials({
            accessToken:
              refreshResult.data.accessToken,
          })
        );

        result =
          await baseQuery(
            args,
            api,
            extraOptions
          );
      } else {
        api.dispatch(
          logOut()
        );
      }
    }

    return result;
  };

export const apiSlice = createApi({
    baseQuery: baseQueryWithReauth,
    endpoints: builder => ({})
})